import React, { FC, ReactElement } from 'react';
import { UseFormReturn } from 'react-hook-form';
import ConnectForm from '../../../../common/reactHookForm/ConnectForm';
import { NbIoTConfigModel } from '@thingslog/repositories';
import NbIoTNetworkConfigurationFields from './NbIoTNetworkConfigurationFields';

const NbIoTNetworkConfiguration: FC<NbIoTNetworkConfigurationProps> = () => {
  return (
    <ConnectForm<NbIoTConfigModel>>
      {({ register, control }: UseFormReturn<NbIoTConfigModel>): ReactElement => (
        <div className="grid grid-cols-4 gap-5">
          <NbIoTNetworkConfigurationFields />
        </div>
      )}
    </ConnectForm>
  );
};

interface NbIoTNetworkConfigurationProps {}

export default NbIoTNetworkConfiguration;
